import classNames from 'classnames';
import { memo, useEffect, useRef } from 'react';

import DotsLoading from '@/components/dots-loading';

import styles from './index.less';

interface IProps {
  className?: string;
  scrollContainerId?: string;
  loadMore: () => Promise<void>;
}

function LoadMore(props: IProps): JSX.Element {
  const { loadMore, className, scrollContainerId = '#scrollContainer' } = props;
  const eleRef = useRef<HTMLDivElement>(null);
  const loadingRef = useRef<boolean>(false);

  useEffect(() => {
    if (!eleRef.current) {
      return;
    }

    function callback(entries: IntersectionObserverEntry[]) {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !loadingRef.current) {
          loadingRef.current = true;

          loadMore().finally(() => {
            loadingRef.current = false;
          });
        }
      });
    }

    const observer = new IntersectionObserver(callback, {
      rootMargin: '300px', // overflow:auto 的时候，rootMargin不生效
      root: scrollContainerId === 'null' ? null : document.querySelector(scrollContainerId),
      threshold: [0.1]
    });

    const delayInMilliseconds = 500;
    const timeoutId = setTimeout(() => {
      eleRef.current && observer.observe(eleRef.current);
    }, delayInMilliseconds);

    return () => {
      clearTimeout(timeoutId);
      observer.disconnect();
    };
  }, [loadMore, scrollContainerId]);

  return (
    <div ref={eleRef} className={classNames(styles.container, className)}>
      <DotsLoading />
    </div>
  );
}

export default memo(LoadMore);
